/** Teléfono clicable → llamada bridge Telnyx (no enlace tel: del sistema). */
export default function CitaLinkTelefono({ telefono, onLlamar, color = "#eab308", style = {} }) {
  const t = telefono != null ? String(telefono).trim() : "";
  if (!t) return null;
  const puede = typeof onLlamar === "function";
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (puede) onLlamar(t);
      }}
      title={puede ? "Clic para llamar (Telnyx)" : undefined}
      style={{
        fontSize: "inherit",
        fontWeight: 600,
        color,
        background: "none",
        border: "none",
        padding: 0,
        cursor: puede ? "pointer" : "default",
        textDecoration: puede ? "underline" : "none",
        fontFamily: "inherit",
        ...style,
      }}
    >
      {t}
    </button>
  );
}
